import React, { useRef } from "react";
import "./Contact.css";
import emailjs from "@emailjs/browser";

export default function Contact() {

  const formRef = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_8yhnyyl",      // 🔁 EmailJS Service ID
        "template_e01wflp",     // 🔁 EmailJS Template ID
        formRef.current,
        "uUAATS6tE3PHct9e9"       // 🔁 EmailJS Public Key
      )
      .then(
        () => {
          alert("Enquiry sent successfully! Our team will contact you soon.");
          formRef.current.reset();
        },
        (error) => {
          console.error("EmailJS Error:", error);
          alert("Something went wrong. Please try again later.");
        }
      );
  };

  return (
    <div className="contact-page">

      {/* ===== CONTACT HERO ===== */}
      <section className="contact-hero">
        <div className="contact-hero-overlay">
          <div className="contact-hero-content">
            <h1>Contact Us</h1>
            <p>
              Let’s discuss your interior needs and create a space you’ll love
            </p>
          </div>
        </div>
      </section>

      {/* ===== SEO CONTENT SECTION ===== */}
      <section className="contact-seo">
        <div className="contact-seo-container">
          <h2>Interior Design & Décor Services in Coimbatore</h2>
          <p>
            <strong>The Blessing Interiors</strong> offers professional interior
            décor solutions in Coimbatore, specializing in custom curtains,
            modern blinds, premium wallpapers, sofa fabrics, and Netlon mosquito
            mesh installation.
          </p>
          <p>
            Whether you are planning a new home interior or upgrading your
            existing space, our team provides personalized consultation,
            quality materials, and professional installation services.
          </p>
        </div>
      </section>

      {/* ===== CONTACT CONTENT ===== */}
      <section className="contact-section">
        <div className="contact-container">

          {/* LEFT IMAGE */}
          <div className="contact-image">
            <img
              src="/images/contact-interior.jpg"
              alt="Interior Design Consultation in Coimbatore"
            />
          </div>

          {/* RIGHT FORM */}
          <div className="contact-form-box">
            <h2>Get in Touch</h2>
            <p className="contact-subtext">
              Share your details and our team will contact you shortly.
            </p>

            <form ref={formRef} className="contact-form" onSubmit={handleSubmit}>

              <div className="form-group">
                <label>Name</label>
                <input
                  type="text"
                  name="name"
                  placeholder="Your name"
                  required
                />
              </div>

              <div className="form-group">
                <label>Phone</label>
                <input
                  type="tel"
                  name="phone"
                  placeholder="Your phone number"
                  required
                />
              </div>

              <div className="form-group">
                <label>Location</label>
                <input
                  type="text"
                  name="location"
                  placeholder="Your area / city"
                  required
                />
              </div>

              <div className="form-group">
                <label>Service Required</label>
                <select name="service" required>
                  <option value="">Select service</option>
                  <option>Custom Curtains</option>
                  <option>Blinds</option>
                  <option>Wallpaper Design</option>
                  <option>Sofa Fabrics</option>
                  <option>Mosquito Net</option>
                </select>
              </div>

              <div className="form-group">
                <label>Notes</label>
                <textarea
                  name="message"
                  rows="3"
                  placeholder="Briefly explain your requirement"
                  required
                ></textarea>
              </div>

              {/* AUTO TIME FIELD */}
              <input
                type="hidden"
                name="time"
                value={new Date().toLocaleString()}
              />

              <button type="submit" className="contact-btn">
                Submit Enquiry
              </button>

            </form>
          </div>

        </div>
      </section>

      {/* ===== GOOGLE MAP ===== */}
      <section className="contact-map">
        <iframe
          title="The Blessing Interiors Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15665.390179305348!2d77.01641173665934!3d11.012529605932666!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba8573e66210ead%3A0x3409c6074c861b78!2sThe%20blessing%20interiors!5e0!3m2!1sen!2sus!4v1765959431294!5m2!1sen!2sus"
          loading="lazy"
        ></iframe>
      </section>

    </div>
  );
}
